const CHANGE_RESULT = "CHANGE_RESULT";
const CHANGE_VIEW_MODE = "CHANGE_VIEW_MODE";

export { CHANGE_RESULT, CHANGE_VIEW_MODE };
